import { Box } from "@mui/material";
import React from "react";
import "../Suites.css";

interface TextNavItemProps {
  title: string;
  icon: any;
  isActive: boolean;
  sourceWorkflow?:boolean
}

export const SuiteAppSidebarItem = ({ title, icon, isActive, sourceWorkflow }: TextNavItemProps) => {
  return (
    <Box
      className={`text-nav-item ${isActive && "active"} ${title.toLowerCase()}`}
      sx={{ textDecoration: "none !important", margin: 0 }}
    >
      <Box sx={{ display: "flex", alignItems: "center",border:sourceWorkflow?"1px solid":"none" ,borderRadius:sourceWorkflow?"50%":"0%",padding:sourceWorkflow?"8px":"0px"}}>{icon}</Box>
      <span
        className={`text-nav-item-name ${isActive && "active"}`}
        style={{ textDecoration: "none !important" }}
      >
        {title==="Image Generator" ? "Text to Image":title}
      </span>
    </Box>
  );
};
